import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const VEHICLETECHNOLOGY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.VehicleTechnology.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.VehicleTechnology.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .checkbox('isLowImpactTechnology', 'Entity.VehicleTechnology.IsLowImpactTechnology')
    .build(),
];

export const VEHICLETECHNOLOGY_CONFIG = {
  entityName: 'VehicleTechnology',
  localizationKey: 'General::Entity.VehicleTechnology',
  fields: VEHICLETECHNOLOGY_FIELDS,
  permission: 'GeneralMachinesAndVehicles.VehicleTechnologies',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
